import { render } from "./TipCard.vue?vue&type=template&id=02eec4b2&scoped=true"
import script from "./TipCard.vue?vue&type=script&lang=js"
export * from "./TipCard.vue?vue&type=script&lang=js"

import "./TipCard.vue?vue&type=style&index=0&id=02eec4b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02eec4b2"]])

export default __exports__